import { render, staticRenderFns } from "./dashboardStatsByPriority.vue?vue&type=template&id=56ed7e8e&"
import script from "./dashboardStatsByPriority.vue?vue&type=script&lang=js&"
export * from "./dashboardStatsByPriority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports